import { type StatsigEnvironment } from 'statsig-js';

import { ENV } from '../app/apiScreenSlice';
import { getEnv } from '../utils/environments';

// client keys
export const statsigProductAccountUUIDKey =
  'client-UPPFBPsHRXUKhVU4xbR05CD1xB0vdgb3MsHNNx0ILzo';

const STATSIG_ENVS: Record<ENV, string> = {
  [ENV.LOCAL]: 'staging',
  [ENV.STG]: 'staging',
  [ENV.SBX]: 'sandbox',
  [ENV.PREPRD]: 'preprd',
  [ENV.PROD]: 'production',
} as const;

export const getStatsigEnvironment = (): StatsigEnvironment => {
  const url = new URL(window.location.href);
  const domain = url.hostname;
  const [env] = getEnv(domain);

  const environment = STATSIG_ENVS[env] ?? 'development';

  return { tier: environment };
};
